import type { AxiosError } from 'axios';
import { isNil } from 'lodash';
import type { Document } from 'models/document/document';
import userService from 'services/userService';
import type { SWRResponse } from 'swr';
import useSWR, { mutate } from 'swr';

type SWRUserDocumentsData = Document[];
const SWR_USER_DOCUMENTS_KEY = 'user-documents-access';

const useUserDocuments = (
  userId: number,
  load = true
): SWRResponse<SWRUserDocumentsData, AxiosError> & {
  updateDocuments: (documentIds: number[]) => Promise<void>;
} => {
  const key = !isNil(load) && load ? ([SWR_USER_DOCUMENTS_KEY, userId] as const) : null;

  const swrResponse = useSWR<SWRUserDocumentsData, AxiosError, typeof key>(
    key,
    async ([_, userId]) => await userService.getDocumentsAsync(userId)
  );

  const updateDocuments = async (documentIds: number[]): Promise<void> => {
    if (!load) return;

    await userService.putDocumentAccessesAsync(userId, documentIds);
    await mutate([SWR_USER_DOCUMENTS_KEY, userId]);
  };

  return {
    ...swrResponse,
    updateDocuments,
  };
};

export default useUserDocuments;
